import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Helpers de formulário
import InputMask from 'react-input-mask';
import Select from 'react-select';

class SuppliersEditTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: 0,
      countries: [],
      id: this.props.supplier_id,
      name: this.props.supplier_data.name,
      address: this.props.supplier_data.address,
      city: this.props.supplier_data.city,
      province: this.props.supplier_data.province,
      country_id: this.props.supplier_data.country_id,
      phone: this.props.supplier_data.phone,
      email: this.props.supplier_data.email,
      zipcode: this.props.supplier_data.zipcode,
      observations: this.props.supplier_data.observations,
    };

    //bind específico
    this.edit = this.edit.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  } 
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  // LM
  componentWillReceiveProps(newProps) {
    if(this.state.loaded === 0 && typeof newProps.supplier_data.name !== 'undefined' && Array.isArray(newProps.countries)) {
      this.setState({
        id: newProps.supplier_id,
        name: newProps.supplier_data.name,
        address: newProps.supplier_data.address,
        city: newProps.supplier_data.city,
        province: newProps.supplier_data.province,
        country_id: newProps.supplier_data.country_id,
        phone: newProps.supplier_data.phone,
        email: newProps.supplier_data.email,
        observations: newProps.supplier_data.observations,
        countries: newProps.countries,
        loaded: 1,
      });
    }
  }
  
  // Fetch salvando a edição
  edit(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
      id: this.state.id,
      name: this.state.name,
      address: this.state.address,
      city: this.state.city,
      province: this.state.province,
      country_id: this.state.country_id,
      phone: this.state.phone,
      email: this.state.email,
      zipcode: this.state.zipcode,
      observations: this.state.observations,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/fornecedor', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.props.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  render() {
    return (
<div>
  <RequestApi ref={'request_api'} />
  <div>
    <form onSubmit={this.edit}>
      <div className="row">
        <div className="col-md-6">
          <div className="form-group">
            <label>Nome:</label>
            <input type="text" name="name" className="form-control" placeholder="Nome do fornecedor" value={this.state.name} onChange={this.handleChange.bind(this, 'name')} />
          </div>
        </div>
        <div className="col-md-6">
          <div className="form-group">
            <label>Endereço:</label>
            <input type="text" name="address" className="form-control" placeholder="Endereço do fornecedor" value={this.state.address} onChange={this.handleChange.bind(this, 'address')} />
          </div>
        </div>
      </div>  
      <div className="row">
        <div className="col-md-6">
          <div className="form-group">
            <label>Cidade:</label>
            <input type="text" name="city" className="form-control" placeholder="Cidade do fornecedor" value={this.state.city} onChange={this.handleChange.bind(this, 'city')} />
          </div>
        </div>
        <div className="col-md-6">
          <div className="form-group">
            <label>Estado:</label>
            <input type="text" name="province" className="form-control" placeholder="Estado/Provincia do fornecedor" value={this.state.province} onChange={this.handleChange.bind(this, 'province')} />
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-6">
          <div className="form-group">
            <label>País:</label>
            <Select
              className="form-field-name"
              name="country_id"
              value={this.state.country_id}
              searchable={true}
              placeholder={'Selecionar país'}
              onChange={this.handleSelectChange.bind(this, 'country_id')}
              options={this.state.countries}
            />    
          </div>
        </div>
        <div className="col-md-6">
          <div className="form-group">
            <label>CEP:</label>
            <InputMask value={this.state.zipcode}  maskChar={null} name="zipcode" mask="99999-999" className="form-control" onChange={this.handleChange.bind(this, 'zipcode')} placeholder={'CEP do fornecedor'} />
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-6">
          <div className="form-group">
            <label>Telefone:</label>
            <InputMask value={this.state.phone}  maskChar={null} name="phone" mask="(99) 9999-99999" className="form-control" onChange={this.handleChange.bind(this, 'phone')} placeholder="Telefone do fornecedor" />
          </div>
        </div>
        <div className="col-md-6">
          <div className="form-group">
            <label>E-mail:</label>
            <input type="text" name="email" className="form-control" placeholder="E-mail do fornecedor" value={this.state.email} onChange={this.handleChange.bind(this, 'email')} />
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-12">
          <div className="form-group">
            <label>Observações:</label>
            <textarea style={{ height: 200 }} type="text" name="observations" className="form-control" value={this.state.observations} onChange={this.handleChange.bind(this, 'observations')} />
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-12">
          <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> Salvar edição</button>
        </div>
      </div>
    </form>
  </div>
</div>
    );
  }
}

export default SuppliersEditTab;



// WEBPACK FOOTER //
// ./src/Components/Suppliers/Elements/SuppliersEditTab.js